import React, { useState, useMemo } from 'react';
import { adminApi } from '../../services/api';
import SalesTablePage from '../../components/sales/shared/SalesTablePage';
import {
  setOpportunitiesData,
  updateOpportunity,
  trackCellEdit,
  clearEditedRows,
  clearEditedRowsForOpportunity,
  discardEdits,
  setLoading,
  setRefreshing,
  setSaving,
  setError,
  clearError,
  selectOpportunitiesData,
  selectEditedRows,
  selectEditedRowsCount,
  selectLoading,
  selectRefreshing,
  selectSaving,
  selectError,
} from '../../components/redux/slices/sales-module/salesOpportunitySlice';

/**
 * Sales Opportunities Page
 * Thin wrapper around SalesTablePage configured for opportunities
 */
const SalesOpportunityPage = () => {
  const [statusMessage, setStatusMessage] = useState(null);

  const config = useMemo(() => ({
    entityType: 'opportunity',
    entityName: 'Sales Opportunity',
    entityNamePlural: 'Sales Opportunities',
    basePath: '/admin/sales/opportunities',
    api: {
      getAll: adminApi.getSalesOpportunities,
      getOne: adminApi.getSalesOpportunity,
      update: adminApi.updateSalesOpportunity,
      delete: adminApi.deleteSalesOpportunity,
    },
    redux: {
      actions: {
        setData: setOpportunitiesData,
        updateEntity: updateOpportunity,
        trackCellEdit,
        clearEditedRows,
        clearEditedRowsForEntity: clearEditedRowsForOpportunity,
        discardEdits,
        setLoading,
        setRefreshing,
        setSaving,
        setError,
        clearError,
      },
      selectData: selectOpportunitiesData,
      selectEditedRows,
      selectEditedRowsCount,
      selectLoading,
      selectRefreshing,
      selectSaving,
      selectError,
    },
    onStatusMessage: setStatusMessage,
  }), []);

  return (
    <>
      {statusMessage && (
        <div className={`alert alert-${statusMessage.type === 'error' ? 'danger' : statusMessage.type} alert-dismissible fade show`} role="alert">
          <i className={`fas fa-${statusMessage.type === 'success' ? 'check-circle' : 'exclamation-triangle'} me-2`}></i>
          {statusMessage.message}
          <button
            type="button"
            className="btn-close"
            onClick={() => setStatusMessage(null)}
            aria-label="Close"
          ></button>
        </div>
      )}
      <SalesTablePage config={config} />
    </>
  );
};

export default SalesOpportunityPage;
